import { Injectable } from '@angular/core';
import { HttpClientHelper } from '../http-helper';
import { ApiUrlHelper } from '../api-url-helper';
// import { AppStore } from '../../app.store';
// import { Store } from 'redux';
// import { UsersState } from '../../app.reducer';
import { Utility } from '../utility';
// import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';
import { UserService } from '../user/user.service';
import { ToastService } from '../toast/toast.service';
// import { HttpHeaders } from '@angular/common/http';
import { delay, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private _http: HttpClientHelper,
    // @Inject(AppStore) private store: Store<UsersState>,
    private userService: UserService,
    private toast: ToastService,
    private _apiHelper:ApiUrlHelper,
    private _utility:Utility

  ) {



  }
  // get user() {
  //   return this.store.getState()['users'] as UsersState;
  // }

  removeChannel(keys) {
    // var token = this.getToken();
    var apiURL = this._apiHelper.NEWSAPI_ENDPOINT() + "/user/RemoveSubscription"// HttpClientHelper.JSONtoQueryString(token);
    return this._http.post(apiURL, { keys: keys }, null)
      .pipe();
  }

  public getToken() {
    return Object.assign({}, this._http.token);
  }
  public getMyVideo(data) {

    // var token = this.getToken();
    var apiURL = this._apiHelper.NEWSAPI_ENDPOINT() + "/user/GetMyVideo"// HttpClientHelper.JSONtoQueryString(token);
    return this._http.post(apiURL, data, null)
      .pipe();
  }
  public getMyVideoList(pageView, tab, spaceUid?, isSpace = false) {
    if (pageView.status === '' && isSpace) {
      pageView['filter'] = 1;
    }
    var token = this.getToken();
    // pageView.touid = spaceUid ? spaceUid : token.uid;
    if (tab === 'video') {
      var apiURL = this._apiHelper.NEWSAPI_ENDPOINT() + "/user/GetMyVideoList" // HttpClientHelper.JSONtoQueryString(token);
    } else {
      var apiURL = this._apiHelper.APIV3_ENDPOINT() + "/user/GetMyVideoList" // HttpClientHelper.JSONtoQueryString(token);
    }
    return this._http.post(apiURL, {...pageView, touid: spaceUid ? spaceUid : token.uid}, null)
      .pipe(map(res => {
        return res.map(r => {
          return {
            count: r.count, result: r.result.map(item => {
              item.image = item.image.replace('s.', '.')
              return item;
            })
          }
        });
      }));
  }

  saveSVideo(data) {
    var token = this.getToken();
    var apiURL = this._apiHelper.NEWSAPI_ENDPOINT() + "/user/SaveVideo"// HttpClientHelper.JSONtoQueryString(token);
    return this._http.post(apiURL, data, null).pipe();
  }

  deleteVideo(ids, tab) {
    var token = this.getToken();
    if (tab === 'video') {
      var apiURL = this._apiHelper.NEWSAPI_ENDPOINT() + "/user/DeleteMyVideo" // HttpClientHelper.JSONtoQueryString(token);
    } else {
      var apiURL = this._apiHelper.APIV3_ENDPOINT() + "/user/DeleteMyVideo" // HttpClientHelper.JSONtoQueryString(token);
    }
    return this._http.post(apiURL, ids, null).pipe();
  }
  /*
  **
  */
  updateMyIndex(id, status) {
    // var token = this.getToken();
    var apiURL = this._apiHelper.NEWSAPI_ENDPOINT() + "/user/UpdateMyIndex"// HttpClientHelper.JSONtoQueryString(token);
    return this._http.post(apiURL, {
      id: id,
      status: status
    }, null).pipe();
  }
  /*
  ** 获取发布服务器
  */
  public getSVideoPublishPoint() {
    var apiURL = this._apiHelper.NEWSAPI_ENDPOINT() + "/user/getpublishpoint"// HttpClientHelper.JSONtoQueryString(token);
    return this._http.get(apiURL, false)
      .pipe();
  }

  public createSVideo(data) {
    var apiURL = this._apiHelper.NEWSAPI_ENDPOINT() + "/user/CreateVideoFile" // HttpClientHelper.JSONtoQueryString(token);
    return this._http.post(apiURL, data, null)
      .pipe();
  }

  /*
  //获取用户频道
  */
  public getUserChannel(navKey) {
    // var token = this.getToken();
    var apiURL = this._apiHelper.NEWSAPI_ENDPOINT() + "/user/GetChannel";
    return this._http.post(apiURL, { key: navKey }, null)
      .pipe();
  }

  /*
 //获取用户频道
 */
  public getUserChannelVideoList(navKey, page): Observable<Array<any>> {
    // var token = this.getToken();
    var apiURL = this._apiHelper.NEWSAPI_ENDPOINT() + "/user/GetChannelVideoList" // HttpClientHelper.JSONtoQueryString(token);
    return this._http.post(apiURL, { key: navKey, page: page }, null)
      .pipe();
  }

  public subscriptChannel(navKey) {
    var token = this.getToken();

    if (!!token.uid) {
      var apiURL = this._apiHelper.NEWSAPI_ENDPOINT() + "/user/SubscriptChannel" // HttpClientHelper.JSONtoQueryString(token);
      return this._http.post(apiURL, { key: navKey }, null)
        .pipe();
    }
    else {
      this.toast.showBlackToast("请先登录");
      this.userService.showLoginDialog(true);
      return of(null);
    }
  }

  public getTagFilter(cid) {
    // var token = this.getToken();
    if(cid == "game")
    {
      cid = "games";
    }
    var apiURL = this._apiHelper.NEWSAPI_ENDPOINT() + "/user/GetTagFilter" // HttpClientHelper.JSONtoQueryString(token);
    return this._http.post(apiURL, { cid: cid }, null)
      .pipe();
  }

  public getChannelList(page, order, size) {
    var token = this.getToken();
    token.page = page;
    token.order = order;
    token.size = size;
    var apiURL = this._apiHelper.NEWSAPI_ENDPOINT() + "/user/GetSubscriptedList" // HttpClientHelper.JSONtoQueryString(token);
    return this._http.post(apiURL, token, null)
      .pipe();
  }

  public getFollowlList(tid, page, order, size, tag) {
    var token = this.getToken();
    token.tid = tid;
    token.page = page;
    token.orderBy = order;
    token.size = size;
    token.tags = tag;
    var apiURL = this._apiHelper.APIV3_ENDPOINT() + "/user/GetAttensionList";
    return this._http.post(apiURL, token, null)
      .pipe();
  }

  public SetAttension(userKey) {
    var token = this.getToken();
    // token.touid = touid;
    token.key = userKey;
    var apiURL = this._apiHelper.APIV3_ENDPOINT() + "/user/SetAttension";
    return this._http.post(apiURL, token, null)
      .pipe(
        delay(
          this.delaySomeMillsecond(500)
        ),
        map(res => {
          if (res.code === 401) {
            return res;
          }
          let followStatus;
          switch (res[0].attentionStatus) {
            case 0:
              followStatus = 'NotFollowed'
              break;
            case 1:
              followStatus = 'Followed'
              break;
            case 2:
              followStatus = 'BiWayFollowed'
              break;

            default:
              break;
          }

          return {
            userId: res[0].id,
            followStatus
          }
        })
      );
  }

  delaySomeMillsecond(millsec): Date {
    var dateObj = Date.now();
    dateObj += millsec;
    return new Date(dateObj);
  }

  // 以下是用于上传剧集的api接口
  public getVideoPublishPoint() {
    var apiURL = this._utility.GetHost("https://m10.{Host}/v3/user/GetPublishPoint");
    return this._http.get(apiURL, false);
  }

  public createVideo(data) {
    var apiURL = this._utility.GetHost("https://m10.{Host}/v3/user/CreateVideoFile"); // HttpClientHelper.JSONtoQueryString(token);
    return this._http.post(apiURL, data, null);
  }

  saveVideo(data) {
    var apiURL = this._utility.GetHost("https://m10.{Host}/v3/user/SaveVideo");
    return this._http.post(apiURL, data, null).pipe();
  }

  public getMyVideoById(key: string) {
    var apiURL = this._utility.GetHost(`https://m10.{Host}/v3/user/GetVideoInfoList?id=${key}`);
    return this._http.get(apiURL).pipe(map(r => r[0]));
  }

  public deleteMediaById(id) {
    var apiURL = this._utility.GetHost("https://m10.{Host}/v3/user/DelVideoByVid");
    return this._http.post(apiURL, { IdList: id }, null);
  }

  public updateMediaTitle(title, id) {
    var apiURL = this._utility.GetHost("https://m10.{Host}/v3/user/UpdVideoTitle");
    return this._http.post(apiURL, { title, id }, null);
  }
}
